export default {
    template: '<input ref="valueInput" :value="value" />',
    model:{
        event: 'changemodel'
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-base-components-vue-wrapper/src/kendo-base-input-component/index.js